//Styles
import Styles from "./Wallpapers.module.scss";

import macbook from "../../../icons/macbookbody.png"
import { useEffect, useRef, useState } from "react";
import classnames from "classnames"
import DropDown from "../../drop-down/DropDown";


interface WallpapersPrrops {
    wallpapers: any;
    screensavers: any;
    type: "background" | "screensaver";
}


const Wallpapers = ({ wallpapers, screensavers, type }: WallpapersPrrops) => {
    let ui: any = []
    let colorsUI: any = []

    useEffect(() => {
        setPictures(type === "background" ? wallpapers : screensavers)
    }, [type])

    const [activeBackground, setActiveBackground] = useState(document.documentElement.style.getPropertyValue(`--desktop-${type}-image`) || type === "background" ? "https://iili.io/HZaVQee.webp" : "https://iili.io/HZam7Bs.gif")

    const [newPicture, setPictures] = useState(type === "background" ? wallpapers : screensavers)

    const [screensaverTime, setScreensaverTime] = useState(0)
    const screensaverTimeOptions = [
        {
            id: "5",
            label: "5 sec",
            value: 500
        },
        {
            id: "10",
            label: "10 sec",
            value: 1000
        },
        {
            id: "15",
            label: "15 sec",
            value: 1500
        },
        {
            id: "30",
            label: "30 sec",
            value: 3000
        }

    ]

    const setBackground = (imageLink: string, subType = 0) => {
        setActiveBackground(imageLink)
        if (subType) {
            document.documentElement.style.setProperty((`--desktop-${type}-image`), imageLink)
        }
        else {
            document.documentElement.style.setProperty((`--desktop-${type}-image`), "url(" + imageLink + ") no-repeat")
        }
    }

    const colors = ["black", "#ff8d85", "#f1ff85", "#a2fcd2", "#bd91fa", "#a3a2fc", "#fca2c9", "#ffd0a1"]

    const getSolidColors = () => {
        ui.push(
            <div className={Styles.colors_container}>
                <div className={Styles.title_container}>
                    <div className={Styles.title}>
                        Colors
                    </div>
                </div>
                <div className={Styles.colors}>
                    {
                        colors.map((color:string,index:number) => {
                            return <div className={Styles.color} style={{ backgroundColor: color }} onClick={() => { setBackground(color, 1) }} key={color+"_"+index}></div>
                        })
                    }
                </div>
            </div>
        )
        return colorsUI
    }


    const handleWrap = (index: any) => {
        setPictures({
            ...newPicture
            , [index]: {
                ...newPicture[index],
                isCollapsed: !newPicture[index].isCollapsed
            }
        })
    }

    const getPicturesBlock = () => {
        Object.keys(newPicture).map((type, index) => {
            ui.push(
                <div className={Styles.type_container}key={newPicture[type].id+"_"+index}>
                    <div className={Styles.title_container}>
                        <div className={Styles.title}>
                            {newPicture[type].label}
                        </div>
                        {
                            Object.keys(newPicture[type].options).length > 4 &&
                            (<div className={Styles.total} onClick={() => { handleWrap(type) }}>
                                {`${newPicture[type].isCollapsed ? "Show All" : "HIde"} (${Object.keys(newPicture[type].options).length})`}
                            </div>
                            )
                        }
                    </div>
                    <div className={!newPicture[type].isCollapsed ? classnames(Styles.images, Styles.wrap) : Styles.images} >

                        {
                            newPicture[type].options.map((picture: any,index:number) => {
                                return <div className={Styles.image} onClick={() => { setBackground(picture) }} key={index+"_"+picture}>
                                    <img src={picture} loading="lazy" alt={picture} className={picture === activeBackground ? Styles.active : ""} />
                                </div>
                            })
                        }
                    </div>
                </div>
            )
        })

        return ui
    }

    const handleTimeSelected = (index: number) => {
        setScreensaverTime(index)
    }

    const handleClickPreview=()=>{
        var screensaverElement = document.getElementById("screenSaver")
        if(screensaverElement){
            screensaverElement.style.display="block"
        }
    }

    return (
        <div className={Styles.container}>
            <div className={Styles.top_half}>
                <div className={Styles.desktop}>
                    <img src={macbook} />
                    <div className={classnames(Styles.macbook_wallpaper, Styles[type])}></div>
                </div>
                <div className={Styles.title}>Build In DIsplay</div>
                {
                    type === "screensaver" && (
                        <div className={Styles.button} onClick={handleClickPreview}>
                            Preview
                        </div>
                    )
                }
            </div>
            <div className={Styles.bottom_half}>

                {
                    type === "screensaver" && (
                        <div className={Styles.options}>
                            <div className={Styles.container}>
                                <div className={Styles.label}>Venture Graphic</div>
                                <div className={Styles.dropdown}><DropDown selected={screensaverTime} options={screensaverTimeOptions} handleClick={handleTimeSelected} /></div>
                            </div>
                        </div>
                    )
                }

                <div className={Styles.content} style={{ marginTop: `${type === "screensaver" ? "80px" : "0px"}` }}>
                    {
                        getPicturesBlock()
                    }
                    {
                        getSolidColors()
                    }
                </div>
            </div>
        </div>
    )
}

export default Wallpapers
